<template>
  <div>
    <el-container class="container">
      <el-header class="header">
        <div class="header-inner">
          <!-- Logo -->
          <div class="logo-wrap" @click="reload">
            <img class="logo-img" src="/static/image/home/logo.png" alt="百草元和" />
            <div class="logo-text">
              <span class="logo-cn">百草元和</span>
              <span class="logo-en">BAICAO HEALTH</span>
            </div>
          </div>

          <!-- Desktop Nav Menu -->
          <el-menu class="nav-menu" :default-active="activeIndex" mode="horizontal" active-text-color="#009798"
            text-color="#1a1a1a" @select="handleSelect">
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/Product">关于我们</el-menu-item>
            <el-menu-item index="/Class">百草学堂</el-menu-item>
            <el-menu-item index="/News">百草新闻</el-menu-item>
            <el-menu-item index="/About">百草文化</el-menu-item>
            <el-menu-item index="/TeachingUsage">使用教学</el-menu-item>
            <el-menu-item index="/Partner">合作共赢</el-menu-item>
          </el-menu>

          <!-- Login / User Dropdown (desktop only) -->
          <div class="header-right">
            <!-- Not logged in: green pill button -->
            <button class="login-pill" v-show="token.length == 0" @click="toLogin">立即登录</button>

            <!-- Logged in: avatar dropdown -->
            <el-dropdown class="user-dropdown" v-show="token.length > 0" @command="accountClick">
              <div class="user-trigger">
                <div class="avatar-circle">
                  <img class="avatar-img" :src="userAvator" />
                </div>
                <span class="user-trigger-name">
                  {{ userName }}
                  <span v-if="inheritor == 'Y'" class="red">★</span>
                  <i class="el-icon-arrow-down user-trigger-arrow"></i>
                </span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item class="dropdown-item drop-first" command="">
                  <div class="user-info-box">
                    <span class="user-name">
                      {{ userName }}
                      <span v-if="inheritor == 'Y'" class="red">★</span>
                    </span>
                    <span class="user-type">{{ userTypeText }}</span>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item class="dropdown-item" command="info" v-show="hasUserInfo">个人信息</el-dropdown-item>
                <el-dropdown-item class="dropdown-item" command="order">处方及订单</el-dropdown-item>
                <el-dropdown-item class="dropdown-item" command="contact">我的患者</el-dropdown-item>
                <el-dropdown-item class="dropdown-item" command="address">我的地址</el-dropdown-item>
                <!-- <el-dropdown-item class="dropdown-item" command="points">我的积分</el-dropdown-item> -->
                <el-dropdown-item class="dropdown-item" command="occ" v-show="!isCommonUser">后台管理</el-dropdown-item>
                <el-dropdown-item class="dropdown-item" command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>

          <!-- Mobile toggle (hamburger / close) -->
          <button class="mobile-menu-btn" :class="{ open: mobileMenuOpen }" @click="mobileMenuOpen = !mobileMenuOpen">
            <span></span><span></span><span></span>
          </button>
        </div>
      </el-header>

      <!-- Mobile full-screen menu overlay -->
      <transition name="fade">
        <div v-show="mobileMenuOpen" class="mobile-menu-overlay" @click.self="mobileMenuOpen = false">
          <nav class="mobile-nav">
            <a v-for="item in navList" :key="item.path"
              :class="['mobile-nav-item', { active: activeIndex === item.path }]" @click="navigate(item.path)">
              {{ item.label }}
            </a>
          </nav>
        </div>
      </transition>
      <el-main class="main-body">
        <keep-alive>
          <router-view class="sub-router-view" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view class="sub-router-view" v-if="!$route.meta.keepAlive" />
        <Footer></Footer>
      </el-main>
    </el-container>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px" center>
      <span class="dialog-content">确定退出登录吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="dialog-confirm" type="primary" :loading="oloading" @click="dialogConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <AiChat></AiChat>
  </div>
</template>

<script>
import Footer from "./Footer";
import AiChat from "../ai/AiChat.vue";
import { EventBus } from "../../js/eventbus.js";
export default {
  components: {
    Footer,
    AiChat,
  },
  data() {
    return {
      activeIndex: "/",
      dialogVisible: false,
      userName: "",
      oloading: false,
      token: "",
      userType: [],
      userTypeText: "",
      userAvator: "",
      userInfo: {},
      hasUserInfo: false,
      status: "",
      statusText: "",
      applyText: "医生认证",
      isCommonUser: true,
      inheritor: "",
      mobileMenuOpen: false,
      navList: [
        { path: "/", label: "首页" },
        { path: "/Product", label: "服务项目" },
        { path: "/Class", label: "百草学堂" },
        { path: "/News", label: "百草新闻" },
        { path: "/TeachingUsage", label: "使用教学" },
        { path: "/About", label: "关于我们" },
        { path: "/Partner", label: "合作共赢" },
      ],
    };
  },
  created() {
    console.log("main created");
    this.activeIndex = this.$route.path;
    EventBus.$on("refresh", (msg) => {
      // home消息 刷新
      this.initInfo();
    });
    this.initInfo();
  },
  watch: {
    // 监听路由变化，自动同步导航栏高亮
    $route: {
      immediate: false,
      handler(route) {
        this.activeIndex = route.path;
      },
    },
  },
  methods: {
    initInfo() {
      console.log("initInfo");
      var token = this.$cookies.get("token");
      var userInfo = this.$store.getters.getUserInfo;
      if (this.utils.isEmptyStr(token)) {
        this.$store.commit("updateUserInfo", {});
        this.hasUserInfo = false;
      } else {
        this.token = token;
        this.axios.defaults.headers.common["Authorization"] = token;
        this.axios.defaults.headers.common["appType"] = "pc";
        this.axios
          .get("/api/getInfo", { params: {} })
          .then((res) => {
            console.log(res);
            var data = res.data;
            if (data.code == 200) {
              this.$store.commit("updateUserInfo", data);
              this.userInfo = data;
              this.setUserInfo(data);
            } else if (data.code == 401) {
              this.token = "";
              this.$cookies.remove("token");
              sessionStorage.clear();
              this.$store.commit("updateUserInfo", {});
            } else {
              this.$message({
                message:
                  data.msg && data.msg.length > 0
                    ? data.msg
                    : "获取账户异常，请联系管理员",
                type: "error",
              });
              this.token = "";
              this.$cookies.remove("token");
              sessionStorage.clear();
              this.$store.commit("updateUserInfo", {});
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    setUserInfo(userInfo) {
      var doctor = userInfo.doctor;
      console.log("doctorInfo999", doctor);
      if (userInfo.inheritor) {
        this.inheritor = userInfo.inheritor;
      }
      if (!this.utils.isEmptyObject(doctor)) {
        if (!this.utils.isEmptyStr(doctor.doctorName)) {
          this.userName = doctor.doctorName;
        } else {
          this.userName = userInfo.user.userName;
        }
        this.hasUserInfo = true;
        this.status = doctor.status;
        console.log(this.status);
        if (this.status == "1") {
          this.statusText = "已停用";
        } else if (this.status == "2") {
          this.statusText = "邀请待确认";
        } else if (this.status == "3") {
          this.statusText = "资料待上传";
        } else if (this.status == "4") {
          this.statusText = "认证审核中";
        } else if (this.status == "5") {
          this.statusText = "认证审核失败";
        }
      } else {
        this.userName = userInfo.user.userName;
        this.hasUserInfo = false;
        this.userTypeText = "普通用户";
      }
      var roles = userInfo.roles;
      if (!this.utils.isEmptyStr(roles)) {
        if (this.isUserTypeByValue(roles, "superadmin")) {
          this.isCommonUser = false;
          this.userTypeText = "超级管理员";
          this.userAvator = require("../../../static/image/ic_admin.png").default;
        } else if (this.isUserTypeByValue(roles, "admin")) {
          this.isCommonUser = false;
          this.userTypeText = "管理员";
          this.userAvator = require("../../../static/image/ic_admin.png").default;
        } else if (this.isUserTypeByValue(roles, "level1")) {
          this.isCommonUser = false;
          this.userTypeText = "一级代理";
          this.userAvator = require("../../../static/image/ic_proxy.png").default;
        } else if (this.isUserTypeByValue(roles, "level2")) {
          this.isCommonUser = false;
          this.userTypeText = "二级代理";
          this.userAvator = require("../../../static/image/ic_proxy.png").default;
        } else if (this.isUserTypeByValue(roles, "common_doctor")) {
          this.isCommonUser = false;
          this.userTypeText = "公共版医生";
          this.userAvator = require("../../../static/image/ic_common_doctor.png").default;
        } else if (this.isUserTypeByValue(roles, "hospital_admin")) {
          this.isCommonUser = false;
          this.userTypeText = "医院管理员";
          this.userAvator = require("../../../static/image/ic_admin.png").default;
        } else if (
          this.isUserTypeByValue(roles, "doctor") &&
          this.status == "0"
        ) {
          this.isCommonUser = false;
          this.userTypeText = "认证医生";
          this.userAvator = require("../../../static/image/ic_wjt_doctor.png").default;
        } else {
          this.isCommonUser = true;
          this.userTypeText = "普通用户";
          this.userAvator = require("../../../static/image/ic_common_doctor.png").default;
        }
        console.log(roles);
        console.log(this.userTypeText);
        console.log(this.status);
      } else {
        this.isCommonUser = true;
        this.userTypeText = "普通用户";
        this.userAvator = require("../../../static/image/ic_common_doctor.png").default;
      }
    },
    isUserTypeByValue(roles, val) {
      for (var i = 0; i < roles.length; i++) {
        var value = roles[i];
        if (value == val) {
          return true;
        }
      }
      return false;
    },
    handleSelect(index) {
      this.activeIndex = index;
      this.$router.replace(index);
    },
    navigate(path) {
      this.activeIndex = path;
      this.mobileMenuOpen = false;
      this.$router.replace(path);
    },
    toLogin() {
      this.$router.push("/Login");
    },
    toSignup() {
      this.$router.push("/Signup");
    },
    dialogConfirm() {
      this.dialogVisible = false;
      this.oloading = true;
      this.wjtHttp.post(
        this,
        "/api/logout",
        {},
        false,
        (res) => {
          this.oloading = false;
          var data = res.data;
          if (data.code == 200) {
            this.$message({
              message: "退出成功",
              type: "success",
            });
            this.$cookies.remove("token");
            sessionStorage.clear();
            this.reload();
          } else {
            this.$message({
              message:
                data.msg && data.msg.length > 0
                  ? data.msg
                  : "服务异常，请联系管理员",
              type: "error",
            });
          }
        },
        (err) => {
          this.oloading = false;
        }
      );
    },
    reload() {
      if (this.$route.path != "/") {
        this.$router.replace("/");
      }
      location.reload();
    },
    accountClick(command) {
      if (command == "contact") {
        this.$router.push("/Contact");
      } else if (command == "order") {
        this.$router.push("/order");
      } else if (command == "address") {
        this.$router.push("/address");
      } else if (command == "points") {
        this.$router.push("/points");
      } else if (command == "apply") {
        if (
          this.utils.isEmptyObject(this.userInfo.doctor) ||
          parseInt(this.userInfo.doctor.status) == 3
        ) {
          this.$router.push("/apply");
        } else {
          this.$router.push({
            path: "/applying",
            query: {
              status: this.userInfo.doctor.status,
              remark: this.userInfo.doctor.remark,
            },
          });
        }
      } else if (command == "info") {
        var info = {
          doctorName: this.userInfo.doctor.doctorName,
          doctorSex: this.userInfo.doctor.doctorSex,
          doctorPhonNo: this.userInfo.doctor.doctorPhonNo,
          idNo: this.userInfo.doctor.idNo,
          doctorCertNo: this.userInfo.doctor.doctorCertNo,
          doctorCertImageUrl: this.userInfo.doctor.doctorCertImageUrl,
          inheritor: this.inheritor,
        };
        this.$router.push({
          path: "/userInfo",
          query: { info: JSON.stringify(info) },
        });
      } else if (command == "logout") {
        this.dialogVisible = true;
      } else if (command == "occ") {
        window.open(process.env.DOMAIN_URL + "/occ", "_blank");
      }
    },
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

/* ── Sticky Header ── */
.header {
  position: sticky;
  top: 0;
  z-index: 200;
  width: 100%;
  height: 88px !important;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid #eef3f1;
  display: flex;
  align-items: center;
}

.header-inner {
  width: 100%;
  max-width: 1220px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-sizing: border-box;
}

/* ── Logo ── */
.logo-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  flex-shrink: 0;
}

.logo-img {
  width: 46px;
  height: 46px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.logo-cn {
  font-size: 20px;
  font-weight: bold;
  color: #304744;
  letter-spacing: 1px;
}

.logo-en {
  font-size: 16px;
  color: #527f77;
  letter-spacing: 2px;
}

/* ── Nav Menu ── */
.nav-menu {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  background: transparent !important;
  border: none !important;
  margin: 0 20px;
}

.nav-menu>>>.el-menu-item {
  position: relative;
  font-size: 16px;
  color: #304744;
  border-bottom: none !important;
  padding: 0 18px;
  height: 88px;
  line-height: 88px;
}

.nav-menu>>>.el-menu-item.is-active {
  font-weight: 600;
  color: #009798;
}

.nav-menu>>>.el-menu-item.is-active::after {
  content: '';
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 3px;
  background: #009798;
  border-radius: 2px;
}

.nav-menu>>>.el-menu-item:not(.is-active):hover {
  color: #009798;
  background: transparent !important;
}

/* ── Right Section ── */
.header-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

/* Login text link */
.login-pill {
  font-size: 16px;
  color: #fff;
  background: #009798;
  border: none;
  border-radius: 999px;
  padding: 9px 26px;
  cursor: pointer;
  font-family: inherit;
  letter-spacing: 1px;
  transition: background 0.2s ease;
}

.login-pill:hover {
  background: #007e7f;
}

/* Avatar dropdown */
.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-trigger-name {
  font-size: 16px;
  color: #304744;
  display: flex;
  align-items: center;
  gap: 4px;
}

.user-trigger-arrow {
  font-size: 16px;
  color: #999;
  margin-left: 4px;
}

.avatar-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e8f3ec;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.avatar-img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

/* Dropdown menu items */
.dropdown-item {
  font-size: 16px;
  color: #333;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.dropdown-item:hover {
  color: #009798 !important;
}

.drop-first {
  height: 60px;
  justify-content: flex-start;
  border-bottom: 1px solid #e6e6e6;
  pointer-events: none;
}

.user-info-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
}

.user-name {
  line-height: 28px;
  font-size: 16px;
  color: #304744;
}

.user-type {
  font-size: 16px;
  color: #999;
  line-height: 24px;
}

.red {
  color: #e53935;
}

/* ── Main Body ── */
.main-body {
  width: 100%;
  padding: 0 !important;
  flex: 1;
}

.sub-router-view {
  width: 100%;
}

/* Dialog */
.dialog-cancel {
  margin-right: 30px;
}

.dialog-confirm {
  margin-left: 30px;
  background: #009798;
  border-color: #009798;
}

.dialog-confirm:hover {
  background: #007e7f;
  border-color: #007e7f;
}

.dialog-content {
  font-size: 16px;
}

/* ── Mobile hamburger button (hidden on desktop) ── */
.mobile-menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 24px;
  height: 2px;
  background: #009798;
  border-radius: 2px;
  transition: all 0.3s;
}

.mobile-menu-btn.open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.mobile-menu-btn.open span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ── Mobile overlay transition ── */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ── Tablet ── */
@media screen and (max-width: 1024px) {
  .header {
    height: 60px !important;
  }

  .header-inner {
    padding: 0 24px;
  }

  .nav-menu>>>.el-menu-item {
    height: 60px;
    line-height: 60px;
    padding: 0 12px;
    font-size: 13px;
  }

  .nav-menu>>>.el-menu-item.is-active::after {
    bottom: 14px;
    width: 16px;
    height: 2px;
  }

  .logo-cn {
    font-size: 16px;
  }

  .logo-en {
    font-size: 8px;
  }
}

.mobile-menu-overlay {
  display: none;
}

/* ── Mobile (<=640px) ── */
@media screen and (max-width: 640px) {
  .header {
    height: 56px !important;
  }

  .header-inner {
    padding: 0 16px;
  }

  .logo-img {
    width: 36px;
    height: 36px;
  }

  .logo-cn {
    font-size: 15px;
  }

  .logo-en {
    font-size: 8px;
  }

  .logo-text {
    display: none;
  }

  /* Desktop-only elements hidden */
  .header-right {
    display: none;
  }

  .nav-menu {
    display: none !important;
  }

  /* Show hamburger */
  .mobile-menu-btn {
    display: flex;
  }

  /* Full-screen menu overlay */
  .mobile-menu-overlay {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 56px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    z-index: 199;
    padding: 16px 24px 24px;
    box-sizing: border-box;
  }

  .mobile-nav {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .mobile-nav-item {
    display: flex;
    align-items: center;
    height: 56px;
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: color 0.2s;
  }

  .mobile-nav-item.active,
  .mobile-nav-item:active {
    color: #009798;
    font-weight: 600;
  }
}
</style>
